import { ImpactSimulationResponse } from '@app-types/api/mcube';

export const IMPACT_PU_MOCK: ImpactSimulationResponse = {
    commandesCommercialesEnCours: [
        {
            idCommande: '640088947',

            offresPrincipales: [
                {
                    idOffre: '6836',

                    libelleCommercial: 'Série Spéciale sans engagement 130Go 5G SIM seule',

                    ligneMarche: 'FNB',

                    ligneMarcheConvergent: 'FNB',

                    montantPaye: 14.99,

                    montantPayeApresSimulation: 12.99,

                    tarifTTC: 22.99,

                    avantages: [
                        {
                            action: 'SOUSCRIPTION',

                            dateFinValidite: new Date('2023-11-09T00:00:00.000+01:00'),

                            duree: 0,

                            idOffre: '14275',

                            libelle: 'Toutatis',

                            packFamille: true,

                            remiseTTC: -10,

                            tauxTVA: 20.0,

                            uniteDuree: 'MOIS',
                        },
                        {
                            action: 'RESILIATION',
                            dateFinValidite: new Date('2023-11-08T00:00:00.000+01:00'),
                            duree: 0,
                            idOffre: '14273',
                            libelle: 'Toutatis',
                            packFamille: true,
                            remiseTTC: -3,
                            tauxTVA: 20.0,
                            uniteDuree: 'MOIS',
                        },
                    ],
                },

                {
                    idOffre: '72156229',

                    libelleCommercial: 'Bbox Fit (FTTH) : Internet - Téléphonie',

                    ligneMarche: 'FAI',

                    ligneMarcheConvergent: 'FAI',

                    montantPaye: 24.99,

                    montantPayeApresSimulation: 24.99,

                    niveauGammeConvergent: 'STANDARD',

                    options: [
                        {
                            libelle: 'Frais de location',

                            montantTTC: 3.0,

                            tauxTVA: 20.0,
                        },
                    ],

                    tarifTTC: 29.99,

                    avantages: [
                        {
                            action: 'SOUSCRIPTION',
                            dateFinValidite: new Date('2023-11-09T00:00:00.000+01:00'),

                            duree: 0,

                            idOffre: '72156672',

                            libelle: 'Toutatis',

                            packFamille: true,

                            remiseTTC: -5,

                            tauxTVA: 20.0,

                            uniteDuree: 'MOIS',
                        },
                    ],
                },
            ],
        },
    ],

    contrats: [
        {
            idContrat: '610000368228',

            numeroVoip: '0998628326',

            opApplicable: {
                conditionPourRemises: [
                    {
                        type: 'MULTILIGNE',
                    },

                    {
                        type: 'PACK_FAMILLE_FIXE',
                    },
                ],

                dateFinEngagement: new Date('2025-05-14T02:00:00.000+02:00'),

                gammeConvergence: 'STANDARD',

                idOffre: '656704',

                libelleCommercial:
                    'Série Spéciale Bbox Fibre Internet-TV-Téléphonie à 36,99 euros/mois, engagement 12 mois',

                ligneMarche: 'FAI',

                ligneMarcheConvergent: 'FAI',

                montantPaye: 31.99,

                montantPayeApresSimulation: 31.99,

                niveauGammeConvergent: 'STANDARD',

                options: [
                    {
                        libelle: 'Location Bbox à 3,00 euros/mois',

                        montantTTC: 3.0,

                        tauxTVA: 20.0,
                    },
                ],

                tarifTTC: 36.99,

                avantages: [
                    {
                        action: 'SOUSCRIPTION',

                        dateFinValidite: new Date('2023-11-09T00:00:00.000+01:00'),

                        duree: 0,

                        idOffre: '72156672',

                        libelle: 'Toutatis',

                        packFamille: true,

                        remiseTTC: -5,

                        tauxTVA: 20.0,

                        uniteDuree: 'MOIS',
                    },
                ],
            },
        },

        {
            idContrat: '10045122795',

            msisdn: '0762393002',

            offresSecondaires: [
                {
                    action: 'SOUSCRIPTION',

                    idOffre: '14274',

                    libelleCommercial: 'Economies B.IG -8e',

                    tarifHT: -4.667,

                    tarifTTC: -5.0,

                    tauxTVA: 20.0,

                    typeOffre: 'AVANTAGE',
                },
            ],

            opApplicable: {
                avantages: [
                    {
                        action: 'SOUSCRIPTION',

                        idOffre: '14275',

                        libelle: 'Economies B.IG -8e',

                        packFamille: true,

                        remiseTTC: -10.0,
                    },
                ],

                compatibleAvecRemises: [
                    {
                        type: 'PACK_FAMILLE_MOBILE',
                    },
                ],

                conditionPourRemises: [
                    {
                        type: 'MULTILIGNE',
                    },

                    {
                        type: 'PACK_FAMILLE_MOBILE',
                    },

                    {
                        type: 'PACK_FAMILLE_FIXE',
                    },
                ],

                dateFinEngagement: new Date('2024-09-11T02:00:00.000+02:00'),

                idOffre: '6852',

                libelleCommercial: 'Forfait sans engagement 200Go 5G SIM Seule',

                ligneMarche: 'FNB',

                ligneMarcheConvergent: 'FNB',

                montantPaye: 37.99,

                montantPayeApresSimulation: 35.99,

                tarifTTC: 45.99,
            },
        },
    ],

    recapitulatifPU: {
        forfaitActuel: {
            offresPrincipales: {
                montantGlobal: 135.96,

                montantGlobalCommandesEncours: 52.98,

                montantGlobalOffresDetenues: 82.98,
            },

            remisesToutatis: {
                montantGlobal: 0.0,

                montantGlobalPourCommandesEncours: 0.0,

                montantGlobalPourOffresDetenues: 0.0,
            },
        },

        impactSimulation: {
            offresPrincipales: {
                montantGlobal: 105.96,

                montantGlobalCommandesEncours: 37.98,

                montantGlobalOffresDetenues: 67.98,

                montantGlobalPropose: 0.0,
            },
            remises: {
                montantGlobal: 30.0,
                montantGlobalPourCommandesEncours: 15.0,
                montantGlobalPourOffresDetenues: 15.0,
                montantGlobalPropose: 15.0,
            },
            remisesToutatis: {
                montantGlobal: 30.0,

                montantGlobalPourCommandesEncours: 15.0,

                montantGlobalPourOffresDetenues: 15.0,

                montantGlobalPropose: 15.0,
            },
        },
    },
};
